var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFireSign = function SvgFireSign(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA017",
    strokeWidth: 1.3,
    d: "M8.048 7.027c1.747-1.747 1.999-3.502 1.499-5.5-.5-1.997 3.222 2.117 4.5 5 .807 1.822.386 4.094 1 4.503 1.5 1 2.314-3.188 2.5-3.003s2.5 2.006 3 6.003-3 9-8.5 9-9-4.503-8.5-9.001c.442-3.976 3-5.502 4.5-7.002Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFireSign);
export default ForwardRef;